// jQuery global is injected via esbuild.config.mjs inject option

// Turbo
import "@hotwired/turbo-rails"
import "lodash";

// Bootstrap 3 JS
import "bootstrap-sass/assets/javascripts/bootstrap";

// Stimulus controllers
import "./controllers"

// jQuery plugins
import "selectize";
import select2 from "select2";
if (typeof select2 === "function") select2();
import "bootstrap-multiselect";
import "summernote";
import "pickadate/lib/picker";
import "pickadate/lib/picker.date";

// Cocoon nested forms
import "@nathanvda/cocoon";

// Chartkick + Chart.js
import "chartkick/chart.js";

// App JS
import "./table2csv";
